import { useCallback, useSyncExternalStore } from 'react';
import { ContentAccessUser } from '@amzn/awscat-pattern-library-service-model';

import { useContentEditorService } from '../../contexts/ContentEditorServiceContext';

/**
 * Subscribes to the {@link ContentEditorService} and returns the latest
 * co-authors list (including staged edits). Re-subscribes when the service
 * instance changes.
 */
export function useCoAuthors(): readonly ContentAccessUser[] {
  const service = useContentEditorService();

  // When the service emits 'changed', then re-read the co-authors.
  const subscribe = useCallback(
    (onStoreChange: () => void) => service.on('changed', onStoreChange),
    [service],
  );
  return useSyncExternalStore(subscribe, () => service.coAuthors);
}
